var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 6.72222C90.2122 6.72222 114.278 30.7878 114.278 60.5C114.278 90.2122 90.2122 114.278 60.5 114.278C30.7878 114.278 6.72222 90.2122 6.72222 60.5C6.72222 30.7878 30.7878 6.72222 60.5 6.72222ZM60.5 0C27.0233 0 0 27.0233 0 60.5C0 93.9767 27.0233 121 60.5 121C93.9767 121 121 93.9767 121 60.5C121 27.0233 93.8422 0 60.5 0Z",
    fill: "#E80000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38L83.0111 83.0111",
    stroke: "#E80000",
    strokeWidth: 6.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 83.0112L83.0111 38.0001",
    stroke: "#E80000",
    strokeWidth: 6.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclined);
export default __webpack_public_path__ + "static/media/declined.dedaa8e96a86f560cd09ee0b387c9bf9.svg";
export { ForwardRef as ReactComponent };